<template>
  <div :class="[{ wait: isWorking }, 'ww-customer']">
    <div class="ww-header">
      <div class="ww-subscription-image">
        <img v-if="subscriptionLineItem" :src="subscriptionLineItem.images.large" />
      </div>
      <div v-if="charge" class="ww-subscription-details">
        <h1>{{ subscriptionLineItem.title }}</h1>
        <table class="ww-line-items">
          <tbody>
            <template v-for="(line_items, index) in groupedLineItems">
              <tr :key="index" v-if="line_items[0] != subscriptionLineItem">
                <td>{{ line_items[0].title }} <span v-if="line_items.length > 1 || line_items[0].quantity > 1" ><strong>x{{ sum(line_items, x => x.quantity) }}</strong></span></td>
                <td>${{ line_items[0].price }}</td>
              </tr>
            </template>            
          </tbody>
          <tfoot>
            <tr v-if="charge.total_discounts > 0">
              <td>Subtotal</td>
              <td>${{ charge.total_line_items_price }}</td>
            </tr>
            <tr v-if="charge.total_discounts > 0">
              <td>Discounts</td>
              <td>-${{ charge.total_discounts }}</td>
            </tr>
            <tr>
              <td>Total</td>
              <td>${{ charge.total_price }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="ww-next-order">
        <div v-if="charge" class="ww-next-date">
          <div>Next Order</div>
          <strong>{{ chargeDate }}</strong>
        </div>
        <div v-if="!disableBuyNow" class="ww-sooner">
          <h3>Want it sooner?</h3>
          <button @click="buyNow()">Order Now</button>
        </div>
      </div>
    </div>
    <div v-if="mode" class="modal">
      <div class="modal-inner">
        <h2 v-if="mode == 'swap'">EXCHANGE A WHISKEY</h2>
        <h2 v-if="mode == 'add'">ADD A WHISKEY TO MY SUBSCRIPTION</h2>
        <a class="ww-close-btn" href="#" @click="mode = null"
          >&lt;&lt; Back to My Subscription</a
        >
        <div class="ww-select-whiskey">
          <div class="ww-select-instructions">
            <div v-if="mode == 'swap'" class="ww-select-text">
              Exchange a whiskey by selecting one below. Once you are ready to
              process your exchange, press the Save Changes button below.
            </div>
            <div v-if="mode == 'add'" class="ww-select-text">
              Add an additional whiskey to your next shipment by selecting one
              below. Once you are ready with your selection, press the Save
              Changes button below.
            </div>
            <button
              :disabled="selectedProduct == null"
              @click="selectProduct(selectedProduct)"
              class="alt"
            >
              Save Changes
            </button>
          </div>
          <div class="ww-select-info">
            <div v-if="mode == 'swap'" class="ww-select-detail">
              <div v-if="activeOnetime" class="ww-select-detail-product">
                <h3>Existing Whiskey</h3>
                <img :src="activeOnetime.product.image" />
                <div class="ww-product-title">
                  {{ activeOnetime.product.title }}
                </div>
                <span>${{ activeOnetime.product.price }}</span>
              </div>
              <div class="ww-switch">
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M59.1305 36.4362C59.1305 37.1621 58.8421 37.8584 58.3287 38.3718C57.8153 38.8851 57.1191 39.1735 56.3931 39.1735L9.38536 39.1735L24.6805 54.4687C25.1523 54.9894 25.4058 55.6716 25.3885 56.3741C25.3712 57.0765 25.0844 57.7454 24.5876 58.2423C24.0907 58.7392 23.4218 59.0259 22.7193 59.0432C22.0169 59.0605 21.3347 58.807 20.8139 58.3352L0.837885 38.4071C0.443074 38.0266 0.171619 37.5363 0.0586897 36.9998C-0.0542397 36.4632 -0.00343867 35.9051 0.204511 35.3978C0.41246 34.8905 0.767975 34.4573 1.22499 34.1543C1.68201 33.8514 2.21947 33.6927 2.76774 33.6988L56.3931 33.6988C57.1191 33.6988 57.8153 33.9872 58.3287 34.5005C58.8421 35.0139 59.1305 35.7102 59.1305 36.4362ZM58.3229 20.7783L38.3469 0.850176C38.095 0.585516 37.7926 0.373961 37.4577 0.227984C37.1228 0.0820029 36.762 0.00455696 36.3966 0.000204403C36.0313 -0.00414434 35.6688 0.0646843 35.3304 0.202647C34.9921 0.340605 34.6848 0.544897 34.4267 0.803484C34.1686 1.06207 33.9648 1.36971 33.8275 1.70828C33.6901 2.04685 33.6219 2.4095 33.6269 2.77484C33.6319 3.14018 33.71 3.50081 33.8566 3.8355C34.0031 4.17019 34.2152 4.47215 34.4803 4.72357L49.7754 19.9776L2.76774 19.9776C2.04174 19.9776 1.34548 20.266 0.832117 20.7794C0.318758 21.2928 0.0303565 21.989 0.0303565 22.715C0.0303565 23.441 0.318758 24.1373 0.832117 24.6506C1.34548 25.164 2.04174 25.4524 2.76774 25.4524L56.3931 25.4524C56.935 25.453 57.465 25.2926 57.9158 24.9917C58.3665 24.6908 58.7178 24.2628 58.9251 23.7621C59.0601 23.4294 59.1298 23.074 59.1304 22.715C59.1298 22.355 59.0582 21.9986 58.9196 21.6662C58.7811 21.3339 58.5783 21.0322 58.3229 20.7783Z"
                    fill="#A27059"
                  />
                </svg>
              </div>
              <div v-if="selectedProduct" class="ww-select-detail-product">
                <h3>New Selection</h3>
                <img :src="getImage(selectedProduct)" />
                <div class="ww-product-title">
                  {{ selectedProduct.node.title }}
                </div>
                <span>{{ getPrice(selectedProduct) }}</span>
              </div>
            </div>
            <div
              v-if="mode == 'add' && selectedProduct"
              class="ww-select-detail"
            >
              <div class="ww-select-detail-product">
                <h3>Selection</h3>
                <img :src="getImage(selectedProduct)" />
                <div class="ww-product-title">
                  {{ selectedProduct.node.title }}
                </div>
                <span>{{ getPrice(selectedProduct) }}</span>
                <div>
                  <strong>Quantity</strong>
                  <div class="ww-select">
                  <select v-model="addQty">
                      <option v-for="index in 20" :key="index">
                          {{ index }}
                      </option>
                  </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ww-grid-collection-add">
          <template v-for="(product, index) in allProducts">
            <div
              v-if="showProduct(product)"
              :key="index"
              class="ww-grid-product"
              @click="changeProduct(product)"
            >
              <div
                v-bind:class="{
                  'ww-product-selection': true,
                  selected: product == selectedProduct,
                }"
              >
                <div v-if="product == selectedProduct" class="ww-select-header">
                  Selected
                </div>
                <img :src="getImage(product)" />
                <div class="ww-product-title">{{ product.node.title }}</div>
                <span>{{ getPrice(product) }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-show="isWorking" class="modal isWorking"></div>
    <div v-show="successMessage" class="modal ww-success">
      <div class="ww-success-content">
        <div class="ww-success-header">
          <svg
            style="vertical-align: middle"
            width="40"
            height="38"
            viewBox="0 0 40 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.1468 11.8531L8.72803 16.2719L18.7499 26.2937L39.7093 5.33437L35.2905 0.915625L18.7499 17.4563L13.1468 11.8531Z"
              fill="#1C8B9F"
            />
            <path
              d="M34.0094 15.4531C34.2406 16.5188 34.375 17.6188 34.375 18.75C34.375 27.3656 27.3656 34.375 18.75 34.375C10.1344 34.375 3.125 27.3656 3.125 18.75C3.125 10.1344 10.1344 3.125 18.75 3.125C21.5875 3.125 24.2187 3.94375 26.5156 5.27188L28.8312 2.95625C25.9156 1.09375 22.4656 0 18.75 0C8.39375 0 0 8.39375 0 18.75C0 29.1062 8.39375 37.5 18.75 37.5C29.1062 37.5 37.5 29.1062 37.5 18.75C37.5 16.7063 37.1625 14.7469 36.5594 12.9063L34.0094 15.4531Z"
              fill="#1C8B9F"
            />
          </svg>
          Success
        </div>
        <p>{{ successMessage }}</p>
        <button @click="successMessage = null" class="alt">CONTINUE</button>
      </div>
    </div>
    <div class="ww-selection-header">
      <h1>My Selected Whiskeys</h1>
      <div v-if="onetimes && onetimes.length">
        <button
          @click="
            addQty = 1;
            selectedProduct = firstProduct();
            mode = 'add';
          "
          title="Add a whiskey"
        >
          Add a whiskey
        </button>
      </div>
    </div>
    <div v-if="onetimes" class="ww-grid-collection">
      <div
        v-for="(onetime, index) in onetimes"
        :key="index"
        class="ww-grid-product"
      >
        <img
          v-if="onetime.product && onetime.product.image"
          :src="onetime.product.image"
        />
        <div
          class="ww-product-title"
          v-if="onetime.product && onetime.product.title"
        >
          {{ onetime.product.title }}
        </div>
        <span v-if="onetime.product && onetime.product.price"
          >${{ onetime.product.price }}</span
        >
        <!-- Fix for products without product object  -->
        <div class="ww-product-title" v-else>{{ onetime.product_title }}</div>
        <span></span>
        <button
          class="alt"
          @click="
            selectedProduct = firstProduct();
            activeOnetime = onetime;
            mode = 'swap';
          "
        >
          Swap
        </button>

        <div v-if="!onetime.properties[0] && onetimes.length > minimumSelectedItems" class="ww-remove">
          <a
            v-if="!selectedForRemove"
            href="#!"
            @click="selectedForRemove = onetime.id"
            ><small>remove</small></a
          >
          <div v-if="selectedForRemove === onetime.id" class="remove-dialog">
            <div class="warning center">Remove the product?</div>
            <button @click="removeProduct(onetime.id)">Yes</button>
            <button @click="selectedForRemove = null">No</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!onetimes">Loading...</div>
    <div v-if="onetimes && onetimes.length === 0">
      Check back soon to see what our next feature release will be
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _get from "lodash/get";
import _find from "lodash/find";
import _groupBy from "lodash/groupBy";
import _sumBy from "lodash/sumBy";
import { decodeVariantId, getImage } from "../shopify/helpers";

export default {
  name: "customer",

  components: {},

  props: ["address_id", "allProducts"],

  data: () => ({
    mode: null, // null, add or swap
    isWorking: false,
    successMessage: null,
    activeOnetime: null,
    onetimes: null,
    selectedForRemove: null,
    charge: false,
    groupedLineItems: null,
    subscriptionLineItem: null,
    selectedProduct: null,
    minimumSelectedItems: 1,
    addQty: 1,
    disableBuyNow: true
  }),

  computed: {
    chargeDate() {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      var d = new Date(this.charge.scheduled_at);
      return [monthNames[d.getMonth()], d.getFullYear()].join(" ");
      //return this.charge.scheduled_at.split("T")[0];
    },
  },

  async created() {
    this.onetimes = await this.fetchOnetimesByAddressId();
    let metafields = await this.getMetafields();
    let hideBuyNow = _find(metafields, (m) => m.key == "hide-buy-now");    
    this.disableBuyNow = hideBuyNow && hideBuyNow.value == "1" ? true : false;    
    this.fetchChage();
    sessionStorage.removeItem("rc_onetimes");
    sessionStorage.setItem("rc_onetimes", JSON.stringify(this.onetimes));    
  },

  methods: {
    getPrice(product) {
      return `$${
        product.node.variants &&
        product.node.variants.edges.length &&
        product.node.variants.edges[0].node.price.amount
      }`;
    },
    async getMetafields() {
      try {
        const res = await axios.get(`/metafields`);
        return res.data;
      } catch (err) {
        console.warn('Error: Unable to retrieve metafield data');
      }
    },
    fetchChage() {
      axios
        .get(`/active-charge?address_id=${this.address_id}`)
        .then((res) => {
          this.charge = res.data;
          this.subscriptionLineItem = _find(
            this.charge.line_items,
            (x) => x.type.toLowerCase() == "subscription"
          );
          this.groupedLineItems = _groupBy(this.charge.line_items, "shopify_variant_id");
          if (this.subscriptionLineItem.title.toLowerCase().includes("founder") || this.subscriptionLineItem.title.toLowerCase().includes("cask"))
          {
            this.minimumSelectedItems = 3;
          }
          else
          {
            this.minimumSelectedItems = 1;
          }          
          console.log("Charge Data:", this.charge);
          //console.log("Subscription Item:", this.subscriptionLineItem);
          //console.log("Grouped Line Items", this.groupedLineItems);
        })
        .catch((err) => console.log(err));
    },
    sum(list,lambda) {
      return _sumBy(list,lambda);
    },
    firstProduct() {
      return _find(
        this.allProducts,
        (x) => !x.node.tags.includes("club-nosell")
      );
    },
    getImage,
    async fetchOnetimesByAddressId() {
      try {
        const res = await axios.get(`/onetimes?address_id=${this.address_id}`);
        const onetimes = _get(res, "data").filter(o => o.status == "ONETIME");
        for (const onetime of onetimes) {
          this.mapOnetimeToProduct(onetime);
        }
        return onetimes;
      } catch (err) {
        alert("Error: Unable to retrieve onetimes");
      }
    },
    mapOnetimeToProduct(onetime) {
      const vid = onetime.shopify_variant_id;
      for (const product of this.allProducts) {
        if (vid === decodeVariantId(product)) {
          onetime.product = {
            title: _get(product, "node.title"),
            image: _get(
              product,
              "node.variants.edges[0].node.image.originalSrc"
            ),
            price: _get(product, "node.variants.edges[0].node.price.amount"),
          };
          break;
        }
      }
    },
    changeProduct(selectedProduct) {
      this.selectedProduct = selectedProduct;
    },
    async selectProduct(selectedProduct) {
      // Prepare product data
      // NOTE activeOnetime is available when you swap the product, this.onetimes[0] is used when you add new product
      const product = {
        id: decodeVariantId(selectedProduct),
        title: selectedProduct.node.title,
        price: _get(selectedProduct, "node.variants.edges[0].node.price.amount"),
      };

      // call api
      try {
        this.isWorking = true;
        if (this.mode === "add") {
          const { address_id, next_charge_scheduled_at: nextChargeDate } =
            this.onetimes[0];

          // Add
          for (let i = 0; i < this.addQty; i++) 
          {
            await axios.post("/onetimes", {
              planName: selectedProduct.node.title,
              address_id,
              nextChargeDate,
              product,
            });
          }
          
          this.successMessage = "Successfully added a new product.";
        } else if (this.mode === "swap") {
          await axios.put("/onetimes", {
            id: this.activeOnetime.id,
            product,
          });

          this.successMessage = "Successfully swapped the products";
        }
      } catch (err) {
        alert("Error: Failed to update the product");
      }

      this.refresh();
    },

    async refresh() {
      // Refresh
      this.onetimes = await this.fetchOnetimesByAddressId();
      this.fetchChage();
      this.isWorking = false;
      this.activeOnetime = null;
      this.mode = null;
      this.selectedForRemove = null;
      // setTimeout(() => {
      //   this.successMessage = null;
      // }, 3000);
    },
    formatTitle(activeOnetimeTitle, productTitle) {
      const d = " Delivery - ";
      const s = activeOnetimeTitle.split(d);
      s[1] = productTitle;
      return s.join(d);
    },
    async removeProduct(onetimeId) {
      // call api
      try {
        this.isWorking = true;
        // Delete
        await axios.delete(`/onetimes?id=${onetimeId}`);

        this.successMessage = "Successfully deleted the product.";

        this.refresh();
      } catch (err) {
        alert("Error: Failed to remove the product");
      }
    },
    showProduct(product) {
      return !product.node.tags.includes("club-nosell") && (!product.node.tags.includes("store:cask") || this.subscriptionLineItem.title.toLowerCase().includes("cask") || this.subscriptionLineItem.title.toLowerCase().includes("founder"));
    },
    async buyNow() {
      this.isWorking = true;

      const res = await axios.get(`/buy-now?address_id=${this.address_id}`);

      if (res.data.status === 200) {
        this.successMessage = res.data.message;
      } else {
        alert("Error: Failed update subscription date");
      }
      this.refresh();
    },
  },
};
</script>
<style >
.ww-product-selection {
  border: 3px solid transparent;
  box-sizing: border-box;
  padding: 1.5rem 0.75rem;
  display: grid;
  cursor: pointer;
}

.ww-product-selection.selected {
  border: 3px solid #1c8b9f;
}

.ww-select-header {
  position: absolute;
  background: #1c8b9f;
  color: white;
  text-transform: uppercase;
  padding: 5px 20px;
  transform: translate(-50%, -50%);
  left: 50%;
}

.ww-subscription-details {
  margin: 0 2em;
}
.ww-grid-collection-add {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin-bottom: 60px;
}

.ww-grid-collection-add img {
  width: 100%;
  height: unset;
}

.ww-sooner {
  padding: 15px 30px;
  text-align: center;
  background: #ebe7d6;
  margin-top: 2rem;
}

.ww-sooner h3 {
  margin: 0;
}

.remove-dialog {
  padding: 2em;
  background: #fff;
}

.remove-dialog button {
  min-width: auto !important;
  margin-right: 0.5em !important;
}

.warning {
  color: orange;
}

.center {
  text-align: center;
}

a {
  color: grey;
  margin-left: 0.4em;
}

.ww-next-date {
  margin-top: 2rem;
  font-size: 1.2em;
}

.ww-customer button {
  margin-top: 1rem;
  border-color: #0a485b;
  background: #0a485b;
  color: #fff;
  display: inline-block;
  padding: 14px 28px;
  border-width: 1px;
  border-style: solid;
  vertical-align: top;
  border-radius: 100px;
  transition: opacity 0.2s, box-shadow 0.25s, background-color 0.1s,
    border-color 0.1s, color 0.1s;
  font-family: Zurich, sans-serif;
  font-size: 0.875em;
  line-height: 1.5em;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  cursor: pointer;
  min-width: 8rem;
}

.ww-customer button.alt {
  background: #a27059;
  border-color: #a27059;
}

.ww-customer button.alt:hover {
  background: #d5a38c;
  border-color: #d5a38c;
}

.ww-customer button:hover {
  background: #1c8b9f;
  border-color: #1c8b9f;
}

.ww-customer button:disabled {
  opacity: 0.5;
}

.isWorking {
  cursor: wait;
  z-index: 999;
  background: grey;
  opacity: 0.5;
  display: grid;
  place-items: start center;
}

.modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: #fff;
  padding-top: 10rem;
  z-index: 1;
}

.modal-inner {
  height: 80vh;
  overflow-y: scroll;
  position: relative;
  padding: 0 30px;
}

.ww-close-btn {
  display: block;
  color: grey;
  text-decoration: none;
  font-size: 1.2em;
}

.ww-success {
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.ww-success-content {
  color: #000;
  background: #f8f7f1;
  padding: 35px 55px;
}

.ww-success-content button {
  margin: 20px auto 0px auto;
  display: block;
}

.ww-success-header {
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  color: #1c8b9f;
  margin-bottom: 20px;
}

.ww-grid-collection {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.ww-grid-product {
  display: grid;
  /* place-items: center; */
  padding: 0.75rem;
  position: relative;
  z-index: 0;
}

.ww-grid-product button {
  margin: 0 auto;
}

.ww-grid-product .ww-remove {
  margin: 1em auto;
}

.ww-customer img {
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
}

.ww-select-whiskey {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ww-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5rem;
}

.ww-line-items {
  border-collapse: collapse;
}

.ww-line-items th {
  text-align: left;
}

.ww-line-items td {
  vertical-align: top;
  padding-bottom: 1em;
  line-height: 1em;
}

.ww-line-items td:first-child {
  padding-right: 1em;
}

.ww-line-items tfoot {
  font-weight: 700;
}

.ww-line-items tfoot tr:first-child td {
  border-top: 1px solid #a27059;
  padding-top: 20px;
}

.ww-selection-header {
  border-top: 1px solid #a27059;
  display: flex;
  justify-content: space-between;
  padding: 1.5rem;
}

.ww-next-order {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ww-product-title {
  font-weight: 700;
}

.ww-subscription-image {
  display: flex;
  align-items: center;
}

.ww-select-detail-product {
  margin: 0 auto;
  max-width: 300px;
  flex-basis: 50%;
}

.ww-select-detail {
  display: flex;
}

.ww-select-text {
  font-size: 1.5em;
  margin: 3em 0;
}

.ww-switch {
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.ww-customer .ww-sooner button {
  margin-top: 10px;
}

.ww-select select {
  /* Reset Select */
  appearance: none;
  outline: 0;
  border: 0;
  box-shadow: none;
  /* Personalize */
  flex: 1;
  padding: 0 1em;
  color: black;
  background-color: white;
  background-image: none;
  cursor: pointer;
}
/* Remove IE arrow */
.ww-select select::-ms-expand {
  display: none;
}
/* Custom Select wrapper */
.ww-select {
  position: relative;
  display: flex;
  width: 5em;
  height: 2em;
  border-radius: .25em;
  border: 1px solid gray;
  overflow: hidden;
}
/* Arrow */
.ww-select::after {
  content: '\25BC';
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.25em 0.5em;
  color: gray;
  background-color: lightgray;
  transition: .25s all ease;
  pointer-events: none;
}
/* Transition */
.ww-select:hover::after {
  background-color: gray;
  color: darkgray;
}


@media only screen and (min-width: 767px) {
  .ww-grid-collection {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  .ww-header,
  .ww-select-whiskey {
    flex-direction: row;
  }

  .ww-subscription-image,
  .ww-next-order {
    flex-basis: 30%;
  }

  .ww-subscription-details {
    flex-basis: 40%;
  }

  .ww-select-info,
  .ww-select-instructions {
    flex-basis: 50%;
  }
}
</style>

